export default function conditionalColorConfig(
   passedSeriesConfig,
   conditionalColors,
) {
   return {
      itemStyle: {
         color: (data) => {
            return {
               type: "linear",
               colorStops: [
                  {
                     offset: data.value < 0 ? 0 : 1,
                     color:
                        data.value >=
                        passedSeriesConfig.conditionalColor.threshold
                           ? conditionalColors[0]
                           : conditionalColors[1],
                  },
                  {
                     offset: data.value < 0 ? 0.49 : 0.51,
                     color:
                        data.value >=
                        passedSeriesConfig.conditionalColor.threshold
                           ? conditionalColors[0]
                           : conditionalColors[1],
                  },
                  {
                     offset: 0.5,
                     color: data.color,
                  },
                  {
                     offset: data.value < 0 ? 1 : 0,
                     color: data.color,
                  },
               ],
            };
         },
      },
      emphasis: {
         itemStyle: {
            color: (data) => {
               return {
                  type: "linear",
                  colorStops: [
                     {
                        offset: data.value < 0 ? 0 : 1,
                        color:
                           data.value >=
                           passedSeriesConfig.conditionalColor.threshold
                              ? conditionalColors[0]
                              : conditionalColors[1],
                     },
                     {
                        offset: data.value < 0 ? 0.49 : 0.51,
                        color:
                           data.value >=
                           passedSeriesConfig.conditionalColor.threshold
                              ? conditionalColors[0]
                              : conditionalColors[1],
                     },
                     {
                        offset: 0.5,
                        color: data.color,
                     },
                     {
                        offset: data.value < 0 ? 1 : 0,
                        color: data.color,
                     },
                  ],
               };
            },
         },
      },
   };
}
